import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	taskOneDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.heartbeats-step.task-one-description-non-final',
		defaultMessage: `We've moved {totalHeartbeatCount, plural, one {{totalHeartbeatCount} heartbeat} other {{totalHeartbeatCount} heartbeats}} from Opsgenie to Jira Service Management. They've now moved from Opsgenie address to a new Jira Service Management-based address.\n
You'll need to update the address of the heartbeats wherever they're used in your systems, to ensure the heartbeats work as expected.\n
[Read more about the updated heartbeats](https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Heartbeats)
`,
		description: 'Heartbeats step task one description',
	},
	taskTwoDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.heartbeats-step.task-two-description-non-final',
		defaultMessage: `Looks like {globalHeartbeatCount, plural, one {{globalHeartbeatCount} heartbeat} other {{globalHeartbeatCount} heartbeats}} in Opsgenie aren't assigned to any team. So they weren't synced with Jira Service Management. [Read more about heartbeats without an assigned team](https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Heartbeats)
`,
		description: 'Heartbeats step task two description',
	},
	taskThreeDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.heartbeats-step.task-three-description-non-final',
		defaultMessage: `Looks like you've got more than 2,000 heartbeats in your Jira Service Management site, which are more than the allowed limit. You'll need to remove {heartbeatToBeRemovedCount} so you can add more heartbeats. [Read how to remove excess heartbeats](https://support.atlassian.com/jira-service-management-cloud/docs/set-up-operations-and-complete-your-shift-to-jira-service-management/#Heartbeats)
`,
		description: 'Heartbeats step task three description',
	},
	taskThreeButtonNonFinal: {
		id: 'eoc-changeboarding.transition-home.heartbeats-step.task-three-button-non-final',
		defaultMessage: 'Go to heartbeats in Opsgenie',
		description: 'Heartbeats step task three button',
	},
});
